import axios from "axios";
import { useState } from "react";
import https from "https";
import { projectsData } from "../data/user.data";

function Projects(props) {
  // const [projects, setProjects] = useState([]);

  const [projects, setProjects] = useState(projectsData);

  // const [first, setFirst] = useState(true);

  // if (first) {
  //   axios
  //     .get(props.ProjectsUrl, {
  //       httpsAgent: new https.Agent({ keepAlive: true }),
  //     })
  //     .then((res) => {
  //       // console.log(res.data);
  //       setProjects(res.data);
  //       // console.log(projects)
  //     })
  //     .catch((error) => {
  //       console.log(error.message);
  //     });
  //   setFirst(false);
  // }

  if (projects.length > 0) {
    return (
      <div className="project-section" id="projects">
        <div className="container">
          <h1 className="special-heading">Projects</h1>
          <div className="projects-items">
            <ul className="grid" style={{ paddingLeft: 0 }}>
              {projects.map(({ name, description, url, _id }) => {
                return (
                  <li className="project-item" key={_id}>
                    <h2>
                      <a href={url ? url : "#"} style={{ marginLeft: 0 }}>
                        {name}
                      </a>
                    </h2>
                    <p>{description}</p>
                    {url ? (
                      <button>
                        <a href={url} target="_blank">
                          Project Here
                        </a>
                      </button>
                    ) : (
                      ""
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  } else {
    return "";
  }
}

export default Projects;
